import { modalSaveReport } from '../../modules/modalSaveReport.js';

export const benefiteds = () => {
  modalSaveReport();
};
